export default (str) => {
  // 两次base64解密
  const decode = atob(atob(str));
  return decode;
}